import { useGetProviderSubscriptionsQuery } from "@/redux/apis/subscription/subscriptionPlansApi";
import { useOperator } from "./useOperator";

/**
 * Whether the current operator is on an Enterprise subscription. Reads the operator's
 * active subscription assignment and matches on the plan slug (preferred) or name.
 */
export const useIsEnterprise = (): boolean => {
  const { id } = useOperator();
  const { data } = useGetProviderSubscriptionsQuery(
    {
      providerId: id,
      status: ["active", "pending_cancellation", "trial"],
      limit: 1,
      orderBy: ["startDate:DESC"],
    },
    { skip: !id }
  );

  const subscription = data?.[0]?.subscription;
  // Match on the stable slug; fall back to an exact name match (avoids false positives
  // like "Enterprise Lite").
  return subscription?.slug?.toLowerCase() === "enterprise" || subscription?.name?.toLowerCase() === "enterprise";
};
